<template id="join">
  <div class="container">
    <router-view />
    <loading v-if="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ApiClient, { API } from 'api/client';
import DialogUtil from 'utils/dialog';
import Loading from 'components/Loading';

export default {
  name: 'NaverRepeater',
  components: {
    Loading,
  },
  mixins: [ApiClient],
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    if (!Object.prototype.hasOwnProperty.call(this.$route.query, 'code')) {
      DialogUtil.alert('잘못된 접근입니다.');
      this.$router.go(-1);
      return;
    }
    this.tokenAccessNaver();
  },
  methods: {
    ...mapActions('oauth', ['setOauth', 'clearOauth']),
    async tokenAccessNaver(ctype = 'join') {
      const params = this.$route.query;
      const provider = 'NAVER';
      const SnsLoginApi = this.getApi(API.SNSLOGIN);
      this.isLoading = true;
      await SnsLoginApi.checkToken({
        provider,
        redirectUri: window.location.href.split('?')[0],
        code: params.code,
        state: params.state,
      }).then((res) => {
        const snsStatus = {
          naver: provider,
          user: {
            oauthUid: encodeURIComponent(res.oauthUid),
            memberId: encodeURIComponent(res.memberId),
            provider: encodeURIComponent(res.provider),
          },
        };
        this.setOauth(snsStatus);
        this.isLoading = false;
        this.$router.push(`/login?redirect=${params.state}`);
      }).catch(() => {
        this.clearOauth({ user: {} });
        this.$router.push('/login');
      });
    },
  },
};
</script>
